import { atom, useRecoilValue, useSetRecoilState } from "recoil";

export const temporaryToken = atom({
  key: "temporaryToken",
  default: {
    token: "",
  },
});

export const useTemporaryToken = () => {
  const setTemporaryToken = useSetRecoilState(temporaryToken);
  const token = useRecoilValue(temporaryToken);
  return { token, setTemporaryToken };
};
